// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selector_BS_gj {
  width: 94px !important;
}

.checkboxAndSelectorFlex_Z4d_v {
  margin-top: 24px;
}

.valueFlex_ASiY6 {
  flex-grow : 1;
  align-self : stretch;
}

.valueEditorFlex_CTslh {
  flex-grow: 1;
}

.error_pXAoe {
  border-color : var( --color-danger500 ) !important;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/imagine/forms/editors/ValueUpdateEditor.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kDAAkD;AACpD","sourcesContent":[".selector {\n  width: 94px !important;\n}\n\n.checkboxAndSelectorFlex {\n  margin-top: 24px;\n}\n\n.valueFlex {\n  flex-grow : 1;\n  align-self : stretch;\n}\n\n.valueEditorFlex {\n  flex-grow: 1;\n}\n\n.error {\n  border-color : var( --color-danger500 ) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selector": `selector_BS_gj`,
	"checkboxAndSelectorFlex": `checkboxAndSelectorFlex_Z4d_v`,
	"valueFlex": `valueFlex_ASiY6`,
	"valueEditorFlex": `valueEditorFlex_CTslh`,
	"error": `error_pXAoe`
};
export default ___CSS_LOADER_EXPORT___;
